import { Input, makeStyles } from '@material-ui/core';
import React from 'react';

import { searchInputChanged } from '../../../actions/searchActions';
import { ReactComponent as SearchIconSvg } from '../../../assets/search.svg';
import { useDispatch, useSearchText } from '../../../redux';
import { spacings } from '../../../theme';
import { useEffectOnce } from '../details/useEffectOnce';
import { usePlexRoute } from '../details/usePlexRoute';

export const SearchInput = React.memo(() => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const searchText = useSearchText();
  const [plexRoute, updatePlexRoute] = usePlexRoute();
  const setSearchText = (txt: string): void => {
    dispatch(searchInputChanged(txt));

    if (plexRoute.page !== 'search' && txt.length > 0) {
      // Transition to search
      updatePlexRoute({ searchFilters: { query: txt, previousPage: plexRoute.page }, page: 'search' }, 'replace');
    } else if (plexRoute.page === 'search' && txt.length === 0) {
      // Transition away from search
      updatePlexRoute({ searchFilters: undefined, page: plexRoute.searchFilters?.previousPage || 'feed' }, 'replace');
    } else {
      // Transition in place, just update the searchQuery
      updatePlexRoute({ searchFilters: { ...plexRoute.searchFilters, query: txt } }, 'replace');
    }
  };

  useEffectOnce(() => {
    // TODO: do we need this?
    if (plexRoute?.searchFilters?.query) dispatch(searchInputChanged(plexRoute.searchFilters.query));
  });

  return (
    <div className={classes.root}>
      <SearchIconSvg className={classes.searchIcon} />
      <Input
        className={classes.searchInput}
        placeholder={'Search'}
        fullWidth={true}
        disableUnderline={true}
        onChange={(event: React.ChangeEvent<{ name?: string; value: unknown }>): void => {
          setSearchText(event.target.value as string);
        }}
        value={searchText}
        onKeyUp={(event): void => {
          if (event.key === 'Escape') {
            setSearchText('');
          }
        }}
      />
    </div>
  );
});

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    position: 'relative',
    marginLeft: spacings.xlarge,
    marginRight: spacings.xlarge,
    width: 400,
  },
  searchIcon: {
    position: 'absolute',
  },
  searchInput: {
    display: 'flex',
    height: 60,
    paddingLeft: 28,
  },
  muiPaperRoot: {},
}));
